var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"service"},[_c('h2',[_vm._v("服务保障")]),_c('div',{staticClass:"serviceBox"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('p',[_vm._v(_vm._s(item.name))]),_c('p',[_vm._v(_vm._s(item.desc))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }